import React from 'react'
import { BreadcrumbView } from '../../../../../../context/breadcrumb.context'
import { IconList } from '../../../../../../shared/icon/icon'
import { useParamsInt } from '../../../../../../shared/hooks/location'
import { Menu, MenuPurge, MenuRestore } from '../../../../../../shared/menu/menu'
import { CardFullHeightScrollY } from '../../../../../../shared/card/card-full-height-scroll-y'
import { useApiListAppVersion } from '../../../../../../api-new/state/config'
import { useRoleSysApp } from '../../../../../../role/hook/role-sys'
import { TableAgClient } from '../../../../../../shared/table-builder/table-ag-client'
import { ColumnMenu, ColumnText } from '../../../../../../shared/table-builder/table-columns'
import { recycleErrorMessage } from '../../../../../../shared/error/server-message'
import { ErrorReference } from '../../../../../../shared/error/error-reference'
import { useErrorLine } from '../../../../../../shared/error/use-error-line'

export const AppVersionRecycle = () => {
  const { appID, appStoreID } = useParamsInt()

  const apiListAppVersion = useApiListAppVersion()

  const roleSysApp = useRoleSysApp()

  const [error, failure, setError] = useErrorLine()

  const handleReady = () => apiListAppVersion.get('deleted')
  const handleDestroyed = () => apiListAppVersion.init()

  const handleRestore = async id => {
    setError(null)
    try {
      await apiListAppVersion.put(`${id}/restore`)
    } catch (err) {
      setError(recycleErrorMessage(err, 'That app version was already removed.'), err)
    }
    await apiListAppVersion.get('deleted')
  }

  return (
    <React.Fragment>
      <BreadcrumbView Icon={IconList} text="recycle bin">
        <CardFullHeightScrollY title="recycle bin">
          {error &&
            <p className="text-danger" role="alert">
              {error}
            </p>}
          {error && <ErrorReference error={failure} className="mb-3" />}
          <TableAgClient apiList={apiListAppVersion} onReady={handleReady} onDestoryed={handleDestroyed}>
            <ColumnText field="name" />
            <ColumnText field="code" />
            <ColumnMenu
              menu={row =>
                <Menu small>
                  <MenuRestore onClick={() => handleRestore(row.id)} show={roleSysApp.accessDelete} />
                  <MenuPurge to={`/admin/app/edit/${appID}/store/edit/${appStoreID}/version/recycle/purge/${row.id}`} show={roleSysApp.accessPurge} pin />
                </Menu>}
            />
          </TableAgClient>
        </CardFullHeightScrollY>
      </BreadcrumbView>
    </React.Fragment>
  )
}
